// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3qOu8","box":"WorkspacesBox_box__19vnd","node":"WorkspacesBox_node__15zfp"};